module.exports = __webpack_public_path__ + "img/icon_10.2858bb00.png";